import axios from '@/core/axios';
import { Chart } from './charts.types';

export class ChartsService {
  get(chartId: number): Promise<Chart> {
    return axios.get(`/charts/${chartId}`).then(resp => resp.data);
  }

  getByStatement(statementId: number): Promise<Chart> {
    if (!statementId) throw new Error('Missing statementId in update');
    return axios.get<Chart>(`/charts/statement/${statementId}`).then(resp => resp?.data);
  }

  create(chart: Chart): Promise<Chart> {
    return axios.post<Chart>(`/charts`, { chart }).then(resp => resp?.data);
  }

  update(chartId: number, chart: Partial<Chart>): Promise<Chart> {
    if (!chartId) throw new Error('Missing chart id in update');
    return axios.put<Chart>(`/charts/${chartId}`, { chart }).then(resp => resp?.data);
  }

  updateFile(chartId: number, file: Record<string, File>): Promise<Chart> {
    if (!chartId) throw new Error('Missing chart id in uploadFileChart');
    const formData = Object.entries(file).reduce((prev, curr) => {
      prev.append(`chart[${curr[0]}]`, curr[1]);
      return prev;
    }, new FormData());

    return axios
      .put<Chart>(`/charts/${chartId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(resp => resp?.data);
  }
}

export const chartsService = new ChartsService();
